import styled from 'styled-components';
import { SectionTitle, PaddedContainer } from '../common/styles';

export const BaseContainer = styled(PaddedContainer)`
  position: relative;
  display: flex;
  gap: 40px;
  flex-direction: ${props => (props.theme.isMobile ? 'column' : 'row')};
  align-items: center;

  & > .base-section {
    display: flex;
    flex-direction: column;
    gap: 12px;

    ${props => (props.theme.isMobile ? `
      order: 2;
    ` : `
      width: 50%;
    `)};
  }

  & > .left-section {
    display: flex;
    flex-direction: column;
    gap: 12px;

    ${props => (props.theme.isMobile ? `
      order: 1;
    ` : `
      width: 50%;
    `)};
  }

  & > .right-section {
    ${props => (props.theme.isMobile ? `
      order: 1;
    ` : `
      order: 3;
      max-width: 560px;
      width: 44vw;
      padding-left: 4vw;
    `)};
  }
`;

export const BaseTitle = styled(SectionTitle)`
  position: relative;
  max-width: 449px;
  margin: 0;
  font-family: Lato, Texta, Arial, Helvetica, sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;

  ${props => (props.theme.isMobile && `
    font-size: 40px;
    line-height: 48px;
  `)};
`;

export const BaseDesc = styled.p`
  position: relative;
  max-width: 449px;
  margin: 0;
  color: ${props => props.theme.bodyColor};
  font-size: ${props => (props.theme.isMobile ? '16px' : '18px')};
  line-height: 1.5;
  text-align: left;
`;

export const BaseSection = styled.div`
  ${props => (props.theme.isMobile ? `
    order: 2;
  ` : `
    max-width: 560px;
    width: 44vw;
  `)};
`;

export const LeftSection = styled(BaseSection)`
  ${props => (props.theme.isMobile ? `
    order: 1;
  ` : `
    padding-left: 12px;
  `)};
`;

export const RightSection = styled(BaseSection)`
  ${props => (props.theme.isMobile ? `
    order: 1;
  ` : `
    order: 3;
    padding-left: 4vw;
  `)};
`;

export const FormContainer = styled.div`
  margin-top: 16px;
  text-align: ${props => (props.theme.isMobile ? 'left' : 'center')};

  .prompt, .message-prompt {
    font-size: 16px;
    line-height: 1.3;
    text-align: left;
  }

  .message-prompt {
    font-weight: bold;
  }

  .btn-primary {
    background-color: #183AD9;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: normal;
    padding: 8px 16px;
    font-family: Lato, Texta, Arial, Helvetica, sans-serif;

    &:hover {
      background-color: #19202D;
    }
  }

  .form-group {
    input {
      padding: 0 16px !important;
      height: 40px !important;

      &::placeholder {
        text-transform: none;
      }
    }

    input[type="checkbox"] {
      margin-right: 8px;
      padding: 0 !important;
      width: 24px !important;
      height: 24px !important;
      border: 1px solid #BDC8DB;
      border-radius: 4px;
    }

    label {
      font-size: 16px;
    }

    textarea {
      padding: 8px 16px;

      &::placeholder {
        text-transform: none;
      }
    }
  }
`;
